import { httpCreate } from './http';

const http = httpCreate('/srv/tiny-link');

export const tinyLink = {
	/**
	 * 创建短链
	 * @param { { bizType: 0 | 1; activityId?: number; gatherId?: number; expireTime: number; } } body
	 */
	create(body) {
		return http.post('/create', body);
	},
	/**
	 * 修改短链
	 * @param { number } id
	 */
	update(id, body) {
		return http.post(`/update/${id}`, body);
	},
	/**
	 * 删除短链
	 * @param { number } id
	 */
	delete(id) {
		return http.delete(`/delete/${id}`);
	},
	/**
	 * 获取短链列表
	 * @param { { pageNum: number; pageSize: number; } } params
	 */
	list(params) {
		return http.get('/list', { params });
	},
	/**
	 * 获取直播间短链列表
	 * @param { number } activityId
	 * @param { { pageNum: number; pageSize: number; } } params
	 */
	liveList(activityId, params) {
		return http.get(`/list/activity/${activityId}`, { params });
	},
	/**
	 * 获取合集短链列表
	 * @param { number } gatherId
	 * @param { { pageNum: number; pageSize: number; } } params
	 */
	gatherList(gatherId, params) {
		return http.get(`/list/gather/${gatherId}`, { params });
	},
};
